/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/jsx-props-no-spreading */

// TODO: Add option for modal player 'play_location === "modal"'

import React from 'react';
import {
    string, object, bool, shape,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = () => ({
    container: {
        position: 'relative',
    },
    playButton: {
        position: 'absolute',
        color: 'rgba(255,255,255,.9)',
        margin: '18% 43%',
        fontSize: '150px',
    },
    playButtonShadow: {
        position: 'absolute',
        color: 'rgba(0,0,0,.5)',
        margin: '18.15% 43.15%',
        fontSize: '150px',
    },
    player: {
        width: '100%',
    },
});
export function HTML5Video({ classes, data }) {
    const {
        optional_image,
        alt_source_url,
        autoplay,
    } = data;
    const posterUrl = optional_image?.url || '';

    return (
        alt_source_url ? (
            <div className={classes.container}>
                <video
                    controls="true"
                    {...autoplay}
                    poster={posterUrl}
                    className={classes.player}
                    onClick="this.paused?this.play():this.pause()"
                >
                    <source src={alt_source_url} type="video/mp4" />
                </video>
            </div>
        ) : <>Missing Video Source</>
    );
}

HTML5Video.propTypes = {
    data: shape({
        alt_source_url: string,
        autoplay: bool,
        optional_image: shape({
            url: string,
        }).isRequired,
    }).isRequired,
    play_location: string,
    title: string,
    classes: object.isRequired,
};

HTML5Video.defaultProps = {
    play_location: 'In Place',
    title: '',
};

export default withStyles(styles)(HTML5Video);
